@if (api) {
  <article>
    <h2 class="no-print">Interactive</h2>
    <section class="no-print">
      <h3>{{ api.title }}</h3>
      <p>Key: {{ api.apikey }}</p>
    </section>
    <section class="no-print">
      <h3>Date Range</h3>
      <p>Date ranged API call</p>
      <app-dev-api-craft [api]="api" [filters]="filters"></app-dev-api-craft>
    </section>
    <section class="no-print">
      <h3>Explore</h3>
      <p>Drill into an asset to reveal the API methods available.</p>
      <app-explorer [api]="api" (addToFilter)="addSettingToFilter($event)"></app-explorer>
    </section>
    <h2 class="no-print">Documentation</h2>
    <app-dev-documentation [api]="api"></app-dev-documentation>
  </article>
}

<footer></footer>
